import React, { useState } from 'react';
import { ChevronDown, Loader2, ShieldAlert, ShieldCheck } from 'lucide-react';
import { apiService } from '../../services/api';

// Qui a lu ma boîte mail, et pourquoi (demande de Rémy, 2026-10-23 : « que même avec les accès root ce soit au moins
// difficile et tracé par l'utilisateur »). Chaque lecture de Gmail est comptée par motif ; le serveur dit si la chaîne
// d'empreintes est intacte, et ce navigateur retient la dernière empreinte vue : un journal raccourci depuis la
// dernière visite se voit aussi. Replié par défaut : un lien discret sous les comptes Google.

const ANCHOR_KEY = 'deepflow.mailAccess.anchor';
const WHAT = {
  recherche: ['recherche', 'recherches'], mail: ['mail lu', 'mails lus'], 'en-têtes': ['en-têtes', 'en-têtes'],
  fil: ['fil', 'fils'], 'pièce jointe': ['pièce jointe', 'pièces jointes'],
};

const readAnchor = () => {
  try { return JSON.parse(window.localStorage.getItem(ANCHOR_KEY) || 'null'); } catch { return null; }
};
const writeAnchor = (head) => {
  try { window.localStorage.setItem(ANCHOR_KEY, JSON.stringify(head)); } catch { /* stockage indisponible */ }
};
const hour = (iso) => new Date(`${iso}Z`).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
const dayLabel = (day) => new Date(`${day}T12:00:00Z`).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
const plural = (count, what) => {
  const [one, many] = WHAT[what] || [what, what];
  return `${count} ${count > 1 ? many : one}`;
};

const MailAccessJournal = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const load = async () => {
    setError(null);
    const anchor = readAnchor();
    try {
      const query = anchor ? `?anchor_id=${anchor.id}&anchor_hash=${encodeURIComponent(anchor.hash)}` : '';
      const next = await apiService.get(`/home/mail/access${query}`);
      setData(next);
      if (next.head && next.intact && next.anchor_ok !== false) writeAnchor(next.head);
    } catch (err) {
      setError(err.message);
    }
  };
  const toggle = () => {
    if (!open && !data) load();
    setOpen(!open);
  };
  const acknowledge = () => {
    if (data?.head) writeAnchor(data.head);
    setData({ ...data, anchor_ok: null });
  };

  const altered = data && (!data.intact || data.anchor_ok === false);
  return (
    <div className="pt-1">
      <button type="button" onClick={toggle} aria-expanded={open}
        className="flex items-center gap-1 text-xs text-slate-400 hover:text-slate-600">
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? '' : '-rotate-90'}`} />
        Qui a lu ma boîte mail
      </button>
      {open && (
        <div className="mt-2 space-y-2 rounded-xl border border-slate-100 p-3 text-xs">
          {!data && !error && <p className="flex items-center gap-2 text-slate-500"><Loader2 className="h-3.5 w-3.5 animate-spin" />Chargement…</p>}
          {error && <p className="text-rose-600">{error}</p>}
          {data && (
            <>
              {altered ? (
                <p className="flex items-start gap-1.5 font-semibold text-rose-700">
                  <ShieldAlert className="h-4 w-4 shrink-0" />
                  <span>
                    {!data.intact ? 'Journal altéré : une ligne a été modifiée ou retirée.' : 'Des lignes ont disparu depuis ta dernière visite.'}
                    {data.intact && <button type="button" onClick={acknowledge} className="ml-2 font-normal text-slate-500 underline">J'ai vu</button>}
                  </span>
                </p>
              ) : (
                <p className="flex items-center gap-1.5 text-emerald-700">
                  <ShieldCheck className="h-4 w-4 shrink-0" />
                  Journal intact : chaque lecture de ta boîte par Deepflow y est comptée, avec son motif.
                </p>
              )}
              {data.days.length === 0 ? (
                <p className="text-slate-400">Aucune lecture ces 30 derniers jours.</p>
              ) : data.days.map((day) => (
                <div key={day.day}>
                  <p className="font-semibold capitalize text-slate-700">{dayLabel(day.day)}</p>
                  <ul className="mt-0.5 space-y-0.5">
                    {day.purposes.map((p) => (
                      <li key={p.purpose} className={`flex flex-wrap gap-x-2 ${p.purpose === 'autre' || p.purpose === 'banc' ? 'text-amber-700' : 'text-slate-600'}`}>
                        <span className="font-medium">{p.label}</span>
                        <span className="text-slate-400">
                          {Object.entries(p.what).map(([what, count]) => plural(count, what)).join(', ')}
                          {' · '}{hour(p.first)}–{hour(p.last)}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MailAccessJournal;
